import Button from '@/app/components/Button/Button';
import SectionContainer from '@/app/components/SectionContainer/SectionContainer';
import { useAnalytics } from '@/app/utils/useAnalytics';
import { pushGtmEvent } from '@/utils/gtm';
import { PATH } from 'constants/path';
import { IArticleSummary } from 'types/cms';

import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

import styles from './GuideSection.module.scss';
import { GuideCard } from './components/GuideCard/GuideCard';

export interface GuideSectionProps {
  guides: IArticleSummary[];
}

export const GuideSection = ({ guides }: GuideSectionProps) => {
  const track = useAnalytics();

  if (!guides.length) {
    return null;
  }

  return (
    <div className={styles.guideSection}>
      <SectionContainer className={styles.guideSectionContainer}>
        <div className={styles.headerRow}>
          <div className={styles.titleBlock}>
            <h3>
              Guides for <span>your job search</span>
            </h3>
            <p>Advice from our medical recruitment consultants.</p>
          </div>
          <Button
            href={PATH.ARTICLES}
            variant="outlined"
            className={styles.allArticlesButton}
            iconRight={<KeyboardArrowRight />}
            onClick={() =>
              pushGtmEvent({
                event: 'all_articles_click',
                element: 'All articles',
                event_label: 'all_articles_link',
              })
            }
            trackFunction={eventProps =>
              track('Click', {
                ...eventProps,
                action: 'Job listing guides - All articles',
              })
            }
          >
            All articles
          </Button>
        </div>
        <div className={styles.cardsRow}>
          {guides.map(guide => (
            <GuideCard key={guide.id} article={guide} />
          ))}
        </div>
      </SectionContainer>
    </div>
  );
};

export default GuideSection;
